'use strict'
import { serverApi } from '@/server';

export default {

    /**
     * 获取所有通道
     *
     * @author nick
     *
     * @method GET
     *
     * @url /channels
     *
     * @returns {Promise}
     */
    getAllChannels() {
        const url = '/channels'
        return serverApi.get({}, url);

    },

    /**
     * 获取所有商户
     *
     * @author nick
     *
     * @method GET
     *
     * @url /merchants
     *
     * @returns {Promise}
     */
    getAllMerchants() {
        const url = '/merchants'
        return serverApi.get({}, url);

    },
    /**
     * 获取商户名
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method GET
     * 
     * @url: /select-merchants
     */
    getMerchantsLis(formData) {
        const url = `/select-merchants`;
        return serverApi.get(formData, url);
    },

}
